import { Phone, MessageSquare } from "lucide-react";
import { BUSINESS } from "@/lib/contact";
import { logContact } from "@/lib/log-contact";

export function StickyCallBar() {
  return (
    <div className="fixed bottom-4 left-1/2 z-50 w-full max-w-md -translate-x-1/2 px-3 sm:max-w-lg md:hidden">
      <div className="glass-strong flex items-center gap-2 rounded-full p-2">
        <a
          href={`tel:${BUSINESS.phone}`}
          onClick={() => { void logContact("call"); }}
          className="btn-primary flex flex-1 items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold"
          aria-label="Call now"
        >
          <Phone className="h-5 w-5" />
          Call Now
        </a>
        <a
          href={`sms:${BUSINESS.sms}`}
          onClick={() => { void logContact("text"); }}
          className="btn-accent flex flex-1 items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold"
          aria-label="Text now"
        >
          <MessageSquare className="h-5 w-5" />
          Text
        </a>
      </div>
    </div>
  );
}
